module.exports = __webpack_public_path__ + "img/bg-login1.7f654ddf.png";